import { Link } from "react-router-dom";
import arrowDownIcon from "assets/landing/arrow-down-icon.svg";

const HeroCard = () => {
  return (
    <article className="hero-card max-lg:p-[4.27vw] p-[1.67vw] bg-[#F3F3F8] max-lg:w-full w-[29vw] flex flex-col gap-6 relative z-[20]">
      <div className="flex flex-col gap-2">
        <h3 className="leading-[1.1] font-luxora-regular text-36 max-lg:text-[6.4vw] font-normal text-black">
          Bring Mini Apps into X!
        </h3>
        <p className="text-[#00000099] max-lg:text-[3.735vw] max-lg:max-w-full text-16 leading-[1.1] max-w-[22.857vw]">
          Communities stay active, projects keep
          <br className="lg:hidden" /> engagement alive
        </p>
      </div>
      <Link
        target="_blank"
        rel="noopener noreferrer"
        to={
          "https://chromewebstore.google.com/detail/agntconnect/lgdfffagihonfnkcffpikpifhegcdkge?utm_source=item-share-cb"
        }
        className="h-[4vw] max-lg:h-[12vw] pl-[0.57vw] flex items-center max-lg:pr-[2.13vw] max-lg:pl-[4.26vw] max-lg:py-2 max-lg:flex-row-reverse max-lg:justify-between gap-[1.142vw] install-agnt"
      >
        <div className="size-[2.857vw] max-lg:size-[8.6vw] max-lg:rounded-[3vw] rounded-2xl flex items-center justify-center bg-white shadow-custom">
          <img
            src={arrowDownIcon}
            alt="arrow down"
            className="size-[4.75vw] lg:size-[1.7vw]"
          />
        </div>
        <span className="text-white font-luxora-medium leading-[1.1] max-lg:text-[4.2695vw] text-20 font-normal">
          Install AGNT Connect
        </span>
      </Link>
    </article>
  );
};

export default HeroCard;
